import type { DemandeRemboursementDTO } from '@/features/api/extranet/dto/Demande/DR'
import { SousDispositif as SousDispositifAF } from '@/features/domaine/types/opco/Demande/AF'
import { SousDispositifDRF } from '@/features/domaine/types/opco/Demande/CXPI'
import { SousDispositif as SousDispositifCPRO } from '@/features/domaine/types/opco/Demande/CPRO'
import { SousDispositif as SousDispositifPROA } from '@/features/domaine/types/opco/Demande/PROA'
import type { NaturesFichiersDemandeCallback } from '@/features/domaine/regles-akto/shared'

export const AttestationPresence = 'AttestationPresence' as const
export const JustificatifMission = 'JustificatifMission' as const
export const JustificatifDelegation = 'JustificatifDelegation' as const
export const FactureCoutsPedagogiques = 'FactureCoutsPedagogiques' as const
export const JustificatifRemuneration = 'JustificatifRemuneration' as const
export const JustificatifFraisAnnexes = 'JustificatifFraisAnnexes' as const

export const getNaturesFichiersDR: NaturesFichiersDemandeCallback<DemandeRemboursementDTO> = (demande, _typeContext) => {
  const obligatoires: string[] = [AttestationPresence]
  const facultatifs: string[] = ['Autre']
  // ERWAN : J'ai sourcé les docs sur les sous-dispositifs, car le dispositif du dossier est à "AUCUN"
  if (SousDispositifDRF.includes(demande.sousDispositif as SousDispositifDRF)) {
    obligatoires.push(JustificatifDelegation)
    facultatifs.push(FactureCoutsPedagogiques)
    facultatifs.push(JustificatifRemuneration)
    facultatifs.push(JustificatifFraisAnnexes)
  } else if (['AfFpe', ...SousDispositifAF].includes(demande.sousDispositif)) {
    facultatifs.push(FactureCoutsPedagogiques)
  } else if (SousDispositifCPRO.includes(demande.sousDispositif as SousDispositifCPRO)) {
    facultatifs.push(FactureCoutsPedagogiques)
  } else if (SousDispositifPROA.includes(demande.sousDispositif as SousDispositifPROA)) {
    facultatifs.push(FactureCoutsPedagogiques)
  } else if (demande.sousDispositif === 'CAR') {
    obligatoires.push(FactureCoutsPedagogiques)
  }

  return {
    obligatoires: obligatoires,
    facultatifs: facultatifs,
    facultatifsDefaut: [],
    nombreFichiersMaximum: {},
    nombreFichiersMinimum: {},
  }
}
